import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { StyledLead } from './lead.styled';
var Lead = function Lead(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("686581913"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledLead, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.lead_text_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default Lead;
